import React from 'react';
import { Box, Flex } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { SidebarItem as SidebarItemComponent } from './SidebarItem';
import { SidebarItem, SidebarLink, DIVIDER } from './types';

interface SidebarProps {
  links: SidebarItem[];
  activeUrl: string;
}

export function Sidebar({ links, activeUrl }: SidebarProps) {
  const cq = useContainerQuery();
  const sidebarWidth = cq({ base: 170, md: 200, lg: 220, xl: 240 });

  return (
    <Box w={sidebarWidth} miw={sidebarWidth} data-testid="sidebar">
      <Flex direction="column" gap={cq({ base: 'xxs', xl: 'xs' })}>
        {links.map((item, index) => (
          <SidebarItemComponent
            key={item === DIVIDER ? `divider-${index}` : (item as SidebarLink).href}
            item={item}
            activeUrl={activeUrl}
          />
        ))}
      </Flex>
    </Box>
  );
}
